import { z } from 'zod'

import { NotificationChannel } from './channel'

export enum ActionType {
  Navigate = 'navigate'
}

export const ActionSchema = z.object({
  type: z.enum(ActionType),
  value: z.string().min(1)
})

export type Action = z.infer<typeof ActionSchema>

// Partial notification data that services send to uhura.
// This doesn't contain the 'full' notification data as uhura manages creating the rest of the data for `NotificationDataSchema`.
export const PartialNotificationDataSchema = z.object({
  action: ActionSchema.optional(),
  image: z.string().optional()
})

export type PartialNotificationData = z.infer<typeof PartialNotificationDataSchema>

export const NotificationDataSchema = PartialNotificationDataSchema.extend({
  id: z.ulid(),
  timestamp: z.coerce.date()
})

export type NotificationData = z.infer<typeof NotificationDataSchema>

// Notification data that is JSON encoded to prevent Firebase from modifying the data.
export const EncodedNotificationDataSchema = z
  .object({
    json: z.string()
  })
  .transform<NotificationData>((o) => {
    return NotificationDataSchema.parse(JSON.parse(o.json))
  })

export type EncodedNotificationData = z.infer<typeof EncodedNotificationDataSchema>

export const BaseNotificationSchema = z.object({
  title: z.string(),
  body: z.string(),
  channel: z.enum(NotificationChannel)
})

export const notificationSchema = BaseNotificationSchema.extend({
  data: EncodedNotificationDataSchema.or(NotificationDataSchema)
})

export type Notification = z.infer<typeof notificationSchema>

// A notification that is completely encoded (including the title and body).
// Used when storing and retrievinig notifications from DynamoDB.
export const EncodedNotificationSchema = z.string().transform<Notification>((o) => {
  return notificationSchema.parse(JSON.parse(o))
})

export type EncodedNotification = z.infer<typeof EncodedNotificationSchema>
